<template>
  <widget-template-card
    :template="template"
    :is_selected="is_selected"
    :compose_preview_settings="composePreviewSettings"
    :build_src="buildIframeSrc"
    :send_settings="sendSettingsToWidget"
    :widget_props="widget_props"
    preview_mode="tablet-landscape"
    current_page="form"
    preview_area_class="guest-check-in-preview-area"
    :height="1200"
    @select="$emit('select', template)"
  />
</template>

<script>
import WidgetTemplateCard from '@/components/widget/widget-template-card.vue';
import { buildWidgetIframeSrc, sendSettingsToWidget } from '@/js/widget/widget-preview.js';
import { composeGuestCheckInPreviewParams } from '@/js/widget/guest-check-in-preview-composer.js';

/**
 * Guest Check-In Template Card
 *
 * Thin wrapper around generic widget-template-card.
 * Provides guest-check-in-specific configuration and settings composition.
 */
export default {
  name: 'mGuestCheckInTemplateCard',

  components: {
    WidgetTemplateCard,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    is_selected: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: Object,
      default: () => ({}),
    },

    organization_name: {
      type: String,
      default: 'Your Organization',
    },

    background_image_url: {
      type: String,
      default: null,
    },

    side_image_url: {
      type: String,
      default: null,
    },

    logo_url: {
      type: String,
      default: null,
    },

    use_logo: {
      type: Boolean,
      default: false,
    },

    user_consent_settings: {
      type: Object,
      default: () => ({}),
    },

    comp_custom_fonts: {
      type: Object,
      default: null,
    },
  },

  computed: {
    widget_props() {
      return {
        theme: this.theme,
        organization_name: this.organization_name,
        background_image_url: this.background_image_url,
        side_image_url: this.side_image_url,
        logo_url: this.logo_url,
        use_logo: this.use_logo,
        user_consent_settings: this.user_consent_settings,
        comp_custom_fonts: this.comp_custom_fonts,
        is_test_submission: true,
      };
    },
  },

  methods: {
    composePreviewSettings(props) {
      return composeGuestCheckInPreviewParams(props);
    },

    buildIframeSrc(preview_mode, is_development) {
      return buildWidgetIframeSrc({
        widget_name: 'guest-check-in',
        preview_mode,
        is_development,
      });
    },

    sendSettingsToWidget,
  },
};
</script>

<style scoped lang="scss">
.guest-check-in-preview-area {
  padding: 16px 16px 0 16px;
  flex-shrink: 0;
}
</style>
